 import api from "../service/api";
import { Warehouse, WarehouseLocation, WarehouseTask } from "../types/warehouse";
import { createApiStore } from "./genericStore";
 
export const useWarehouseStore = createApiStore<Warehouse>("/warehouse");
export const useWarehouseLocationStore = createApiStore<WarehouseLocation>("/warehouseLocation");
const useTaskBaseStore = createApiStore<WarehouseTask>("/warehouse/task");

export const useWarehouseTaskStore = () => {
    const store = useTaskBaseStore();

    return {
        ...store,
        // Özel Aksiyonlar (API çağrılarını store içine taşıdık)
    autoAssign: async () => {
            const res = await api.post("/warehouse/task/auto-assign");
            await store.fetchDataDynamic(); 
            return res.data;
        },
        
        adminUpdate: async (id: number, data: any) => {
            const res = await api.put(`/warehouse-task/${id}/admin-update`, data);
            await store.fetchDataDynamic(); 
            return res.data;
        },
     getStaffList: async () => {
    // 1. Body içine sadece filtreyi koyuyoruz
    const requestBody = {
        filter: {
            field: "role.name",
            operator: "eq",
            value: "warehouse_staff"
        }
    };

    // 2. URL Query Parametreleri (pageIndex ve pageSize)
    const urlParams = {
        pageIndex: 1,
        pageSize: 1000
    };

    // TSOA'nın beklediği format: Body'de filtre, URL'de pagination
    const res = await api.post("/user/DynamicQuery", requestBody, { 
        params: urlParams 
    });
    
    // Veriyi dropdown formatına dönüştür
    if (res.data && res.data.items) {
        return res.data.items.map((u: any) => ({ 
            label: u.name, 
            value: u.id 
        }));
    }
    return [];
}
    };
};